module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.data) ? _c('div', {
    staticClass: "left"
  }, [_c('div', {
    attrs: {
      "id": "leftNav"
    }
  }, [_c('div', {
    attrs: {
      "id": "leftNavContainer"
    }
  }, [_c('div', {
    staticClass: "celwidget",
    attrs: {
      "id": "refinements",
      "role": "complementary",
      "aria-label": "过滤结果"
    }
  }, [_c('div', {
    staticClass: "shoppingEngineSectionHeaders",
    attrs: {
      "role": "heading",
      "aria-readonly": "true"
    }
  }, [_vm._v("显示搜索结果：")]), _vm._v(" "), _c('div', {
    staticClass: "categoryRefinementsSection"
  }, [_c('h2', [_vm._v("分类")]), _vm._v(" "), _c('ul', {
    attrs: {
      "id": ""
    }
  }, _vm._l((_vm.category), function(item, index) {
    return _c('li', {
      key: item.key
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)",
        "data": index
      },
      on: {
        "click": function($event) {
          return _vm.changeCat(item.key)
        }
      }
    }, [_c('span', {
      staticClass: "refinementLink"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "narrowValue"
    }, [_vm._v(" (" + _vm._s(item.doc_count) + ")")])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "shoppingEngineSectionHeaders",
    attrs: {
      "role": "heading",
      "aria-readonly": "true"
    }
  }, [_vm._v("筛选：")]), _vm._v(" "), _c('h2', [_vm._v("品牌")]), _vm._v(" "), _c('ul', {
    attrs: {
      "id": ""
    }
  }, _vm._l((_vm.brand), function(item, index) {
    return _c('li', {
      key: item.key,
      staticClass: "refinementImage"
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.changeBrand(item.key)
        }
      }
    }, [_c('span', {
      staticClass: "refinementLink"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "narrowValue"
    }, [_vm._v(" (" + _vm._s(item.doc_count) + ")")])])])
  }), 0), _vm._v(" "), _c('h2', [_vm._v("价格")]), _vm._v(" "), _c('ul', _vm._l((_vm.pricerange), function(item, index) {
    return _c('li', {
      key: item.key
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.changePrice(item.start_price, item.end_price)
        }
      }
    }, [_c('span', {
      staticClass: "refinementLink"
    }, [_vm._v(_vm._s(item.start_price) + "-" + _vm._s(item.end_price) + "元")]), _vm._v(" "), _c('span', {
      staticClass: "narrowValue"
    }, [_vm._v(" (" + _vm._s(item.doc_count) + ")")])])])
  }), 0), _vm._v(" "), _c('hr', {
    staticClass: "s-wayfinding-rule",
    staticStyle: {
      "margin": "5px 0"
    }
  })])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0676ad8a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/goods-godule/module-left-tree.vue
// module id = 1521
// module chunks = 1